import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
//store
import useComnStore from "src/webapp/stores/comn.store";
import usePartnerStore from "src/webapp/stores/partner.store";
//hook
import useAxiosHook from "../comn/axios.hook";

const useMarketHook = () => {
    const params = useParams();
    const navigator = useNavigate();

    //store
    const { partner } = usePartnerStore();
    const { setMessage } = useComnStore();//메세지결과처리
    //hook
    const { axiosPostHandler } = useAxiosHook();
    //라이더마켓 게시글상태수정API
    const isLock = useRef(false);
    const marketUpdateAndDeleteAPI = async (type, data) => {//type 1.등록 2.수정 3.삭제
        if (isLock.current || (type === "3" && !window.confirm('데이터를 삭제한 후에는 다시 복구할 수 없습니다.\n삭제하시겠습니까?'))) { return; }

        setMessage({ type: 2, message: `잠시만 기다려주세요.` });
        isLock.current = true;
        const DATA = {
            SEQ_NO: params.seq
            , PARTNER_CD: partner.COMN_CD
            , SUBMIT_TYPE: 3//등록 및 삭제 유형 - 1.등록, 2.수정, 3.STATUS 변경
            , STATUS: type === 3 ? 'D' : type//거래상태 - 1.거래가능, 2.예약중, 3.거래완료, D.삭제
        };
        const result = await axiosPostHandler(`marketRegAndUpdateForJson.do`, DATA);
        if(!result || result.message !== "SUCCESS") {
            setMessage({ type: 2, message: `잠시 후 다시 시도해주세요.` });
            setTimeout(function () { isLock.current = false; }, 300); return;
        }
        if(result.message === 'SUCCESS') {
            setMessage({ type: 1, message: `처리가 완료되었습니다.` });
            data.STATUS = type;
            if(type === "3") {
                navigator('/market');
            }
            setTimeout(function () { isLock.current = false; }, 300); return;
        }
    }

    return {
        marketUpdateAndDeleteAPI //라이더마켓 게시글상태수정API
    };
}

export default useMarketHook;